
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import LoginForm from "@/components/auth/LoginForm";
import { useAuth } from "@/contexts/AuthContext";

const Login = () => {
  const navigate = useNavigate();
  const { session, isLoading } = useAuth();
  const [searchParams] = useSearchParams();

  // Flag to detect if redirected after email verification
  const isVerification = searchParams.get("verification") === "true";

  useEffect(() => {
    if (!isLoading && session) {
      navigate("/dashboard", { replace: true });
    }
  }, [session, isLoading, navigate]);


  return (
    <div className="min-h-screen bg-[#375062] flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex items-center justify-center gap-3 mb-2">
          <img src="/icon-mark.png" alt="Doyence" className="h-10 w-10" />
          <h1 className="text-3xl font-bold text-white">
            Doyence
          </h1>
        </div>
        <h2 className="text-center text-xl font-semibold text-white">
          {isVerification
            ? "Your email is being verified"
            : "Log in to your account"}
        </h2>

        {isVerification && (
          <p className="mt-2 text-center text-sm text-white/70">
            Please wait while we verify your email address...
          </p>
        )}
      </div>

      {/* Only show login form if we're not in verification state */}
      {!isVerification && (
        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <LoginForm />
        </div>
      )}
    </div>
  );
};

export default Login;
